import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    loginSuccess: (state, action) => {
      const { user, accessToken, refreshToken } = action.payload || {};
      state.user = user || null;
      state.accessToken = accessToken || null;
      state.refreshToken = refreshToken || null;
      state.isAuthenticated = Boolean(user && accessToken);
      state.loading = false;
      state.error = null;
    },

    loginFailure: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = action.payload || 'Login failed';
    },

    setCredentials: (state, action) => {
      const { user, accessToken, refreshToken } = action.payload || {};
      if (typeof user !== 'undefined') {
        state.user = user;
      }
      if (typeof accessToken !== 'undefined') {
        state.accessToken = accessToken;
      }
      if (typeof refreshToken !== 'undefined') {
        state.refreshToken = refreshToken;
      }
      state.isAuthenticated = Boolean(state.user && state.accessToken);
    },

    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
    }
  }
});

export const { loginStart, loginSuccess, loginFailure, setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
